
































import { Pracovnik } from '@/modules/administrace/pracovnik';

import Base from './Base.vue';
import { editMutations } from '../store/types';
import { RozsahDate } from '../constants';

export default Base.extend({
	name: 'VyhodnoceniMechaniku',
	components: {
		BaseFilterSestav: Base,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${editMutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		isVypocetSlevyDisabled(): boolean {
			return this.OhodnoteniVykonu;
		},
	},
	created() {
		this.RozsahDate = RozsahDate.casTentoMesic;
	},
});
